import { useEffect, useRef } from 'react';

const useTypingEffect = (roles, language) => {
  const typingRef = useRef(null);
  const typingTimeoutRef = useRef(null);

  useEffect(() => {
    // Limpiar el timeout anterior cuando cambia el idioma
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current);
    }

    // Resetear el texto del typing
    if (typingRef.current) {
      typingRef.current.textContent = '';
    }

    let currentRoleIndex = 0;
    let currentCharIndex = 0;
    let isDeleting = false;
    let typingSpeed = 100;

    const type = () => {
      const currentRole = roles[currentRoleIndex];

      if (isDeleting) {
        if (typingRef.current) {
          typingRef.current.textContent = currentRole.substring(0, currentCharIndex - 1);
          currentCharIndex--;
        }
        typingSpeed = 50;
      } else {
        if (typingRef.current) {
          typingRef.current.textContent = currentRole.substring(0, currentCharIndex + 1);
          currentCharIndex++;
        }
        typingSpeed = 150;
      }

      if (!isDeleting && currentCharIndex === currentRole.length) {
        isDeleting = true;
        typingSpeed = 1500;
      } else if (isDeleting && currentCharIndex === 0) {
        isDeleting = false;
        currentRoleIndex = (currentRoleIndex + 1) % roles.length;
        typingSpeed = 500;
      }

      typingTimeoutRef.current = setTimeout(type, typingSpeed);
    };

    // Iniciar el efecto de typing
    typingTimeoutRef.current = setTimeout(type, 1000);

    // Limpieza cuando el componente se desmonta o cuando cambian las dependencias
    return () => {
      if (typingTimeoutRef.current) {
        clearTimeout(typingTimeoutRef.current);
      }
    };
}, [language, roles]); // Dependencias correctas

  return typingRef;
};

export default useTypingEffect;